import CloseSmallIcon from 'assets/icons/close-small-icon.svg';
import AddReceiverBizIconBlueSky from 'assets/ver2/icons/add-receiver-biz-icon-blue-sky.svg';
import AddReceiverIconYellow from 'assets/ver2/icons/add-receiver-icon-yellow.svg';
import AddReceiverIcon from 'assets/ver2/icons/header/add-receiver-icon.svg';
import Receivers from 'components/Receivers';
import FilterReceiver from 'components/Receivers/components/FilterReceiver';
import PaginationLazy from 'components/Receivers/components/Pagination/mobile';
import SearchReceiver from 'components/Receivers/components/SearchReceiver';
import {
  convertFilteredKeyFixed,
  fetchReceiversFiltered,
  getBodyPayloadFiltered,
} from 'components/Receivers/func';
import ReceiversMobile from 'components/Receivers/mobile';
import ButtonCommon from 'components/common/ButtonCommon';
import CollapsibleSideMenu from 'components/common/CollapsibleSideMenu';
import OuterBodyContent from 'components/common/CollapsibleSideMenu/OuterBodyContent';
import OuterPathContent, {
  SearchFilterSection,
  Title,
} from 'components/common/CollapsibleSideMenu/OuterPathContent';
import MobileTabMenu from 'components/common/MobileTabMenu';
import NavbarFooter from 'components/common/NavbarFooter/ver3';
import SizeBox from 'components/common/SizeBox';
import {
  BUSINESS_OF_RECEIVER_TYPE,
  PAGE_DEFAULT,
  RECEIVERS_ADD_SUFIX,
  RECEIVER_TABLE_SORT_ORDER_INITIAL,
  RECEIVER_TABS,
} from 'constants';
import { searchTextValid } from 'helpers';
import useAuth from 'hooks/useAuth';
import useBodyContentStatus, { Pill } from 'hooks/useBodyContentStatus';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import useStore from 'hooks/useStore';
import { isArray, isEmpty, isNull } from 'lodash';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { arrayUtils, stringUtils } from 'utils';

const ReceiversPage = () => {
  const { t } = useLang();
  const { token } = useAuth();
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDetectDevice();
  const { state } = useStore();
  let { refreshReceiverList } = state;

  const [receivers, setReceivers] = useState(null);
  const [currentPage, setCurrentPage] = useState(PAGE_DEFAULT);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [sortOrder, setSortOrder] = useState(RECEIVER_TABLE_SORT_ORDER_INITIAL);
  const [applyFiltered, setApplyFiltered] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [isFetching, setFetching] = useState(false);
  const [isSearched, setSearched] = useState(false);
  // Set by an invalid submit; cleared on the next edit or a valid submit. The
  // message shows only while the text is also invalid (isSearchInvalid).
  const [isSearchSubmittedInvalid, setSearchSubmittedInvalid] =
    useState(false);
  const isSearchInvalid =
    isSearchSubmittedInvalid && !searchTextValid(searchValue);
  const [currentTab, setCurrentTab] = useState(0);

  const {
    isShowSearchInput,
    isShowFilterButton,
    isShowActionButton,
    isShowPagingButton,
    isShowPillFiltered,
  } = useBodyContentStatus({
    isFetching,
    list: receivers,
    sorts: sortOrder,
    filters: applyFiltered,
    search: searchValue,
  });

  const isFetchReceiversInitial =
    token &&
    !isArray(receivers) &&
    isEmpty(receivers) &&
    !searchValue &&
    isEmpty(applyFiltered) &&
    Object.values(sortOrder).every((value) => !value) &&
    isNull(refreshReceiverList);

  useEffect(() => {
    if (isFetchReceiversInitial) {
      setFetching(true);
      setReceivers(null);
      fetchReceiversFiltered({
        token,
        page: PAGE_DEFAULT,
        receivers: [],
        setReceivers,
        setCurrentPage,
        setTotalPages,
        setTotalElements,
        setFetching,
        isInitial: true,
      });
    }
  }, [isFetchReceiversInitial]);

  useEffect(() => {
    if (isNull(refreshReceiverList)) return;
    handleTabOnClick(refreshReceiverList);
  }, [refreshReceiverList]);

  const removeFilterByFavourite = () => {
    const newApplyFiltered = {
      ...applyFiltered,
      favoriteSelected: 'all',
    };

    return newApplyFiltered;
  };
  const removeFilterByArray = (key, arr, obj, prop) => {
    const arrayFilter = arrayUtils.removeItemInArrayObject(
      arr,
      obj[prop],
      prop
    );

    if (arrayUtils.isArrayEmpty(arrayFilter)) {
      delete applyFiltered[key];

      return applyFiltered;
    }

    const newApplyFiltered = {
      ...applyFiltered,
      [key]: arrayFilter,
    };
    return newApplyFiltered;
  };
  const handleRemoveFiltered = (typeFilter, value) => {
    if (!searchTextValid(searchValue)) return;

    setFetching(true);

    const removeTypeFilteredReference = {
      countriesSelected: (key, array, country) => {
        return removeFilterByArray(key, array, country, 'code');
      },
      favoriteSelected: () => {
        return removeFilterByFavourite();
      },
    };

    const newApplyFiltered = removeTypeFilteredReference[typeFilter](
      typeFilter,
      applyFiltered[typeFilter],
      value
    );
    setApplyFiltered(newApplyFiltered);

    let bodyPayload = getBodyPayloadFiltered(newApplyFiltered);

    bodyPayload = {
      ...bodyPayload,
      name: searchValue,
      ...(currentTab === 1 && { gender: BUSINESS_OF_RECEIVER_TYPE }),
    };

    setReceivers(null);
    fetchReceiversFiltered({
      token,
      body: bodyPayload,
      page: PAGE_DEFAULT,
      setReceivers,
      setCurrentPage,
      setTotalPages,
      setTotalElements,
      setFetching,
    });
  };

  const renderFilterByArray = (key, arr) => {
    return arr.map((item, index) => (
      <Pill key={`${key}-${index}`}>
        {item.name}{' '}
        <img
          src={CloseSmallIcon}
          width={12}
          height={12}
          alt=""
          onClick={() => handleRemoveFiltered(key, item)}
        />
      </Pill>
    ));
  };
  const renderFilterByFavourite = (key) => {
    return (
      <Pill key={key}>
        {`Favourite: ${stringUtils.capitalize(applyFiltered.favoriteSelected)}`}{' '}
        <img
          src={CloseSmallIcon}
          width={12}
          height={12}
          alt=""
          onClick={() => handleRemoveFiltered(key)}
        />
      </Pill>
    );
  };
  const renderTypeFilteredReference = {
    countriesSelected: (key, array) => {
      return renderFilterByArray(key, array);
    },
    favoriteSelected: (key) => {
      if (applyFiltered[key] === 'all') return null;

      return renderFilterByFavourite(key);
    },
  };

  const handleTabOnClick = (tabIndex) => {
    setFetching(true);
    setReceivers(null);
    setSearchValue('');
    setSearched(false);
    setSortOrder(RECEIVER_TABLE_SORT_ORDER_INITIAL);
    setApplyFiltered(null);
    fetchReceiversFiltered({
      token,
      body: {
        ...(tabIndex === 1 && { gender: BUSINESS_OF_RECEIVER_TYPE }),
      },
      page: PAGE_DEFAULT,
      setReceivers,
      setCurrentPage,
      setTotalPages,
      setTotalElements,
      setFetching,
    });
    setCurrentTab(tabIndex);
  };

  const renderSearchInput = () => {
    if (!isShowSearchInput) return null;
    return (
      <SearchReceiver
        applyFiltered={applyFiltered}
        receivers={receivers}
        setReceivers={setReceivers}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        setTotalPages={setTotalPages}
        setCurrentPage={setCurrentPage}
        setSortOrder={setSortOrder}
        setTotalElements={setTotalElements}
        currentTab={currentTab}
        setFetching={setFetching}
        setSearched={setSearched}
        isSearchInvalid={isSearchInvalid}
        setSearchSubmittedInvalid={setSearchSubmittedInvalid}
      />
    );
  };
  const renderFilterButton = () => {
    if (!isShowFilterButton) return null;
    return (
      <FilterReceiver
        applyFiltered={applyFiltered}
        searchValue={searchValue}
        isSearchInvalid={isSearchInvalid}
        setApplyFiltered={setApplyFiltered}
        setReceivers={setReceivers}
        setTotalPages={setTotalPages}
        setCurrentPage={setCurrentPage}
        setSortOrder={setSortOrder}
        setTotalElements={setTotalElements}
        currentTab={currentTab}
        setFetching={setFetching}
      />
    );
  };
  const renderActionButton = () => {
    if (!isShowActionButton) return null;
    if (!isDesktop) return null;
    return (
      <ButtonCommon
        value={t('button_add_new_receiver')}
        color="var(--c-primary)"
        background="var(--bg-primary)"
        isFill={true}
        styles={{
          paddingInline: 0,
        }}
        buttonIconStyles={{
          float: 'right',
        }}
        iconSrc={AddReceiverIcon}
        onClick={() => navigate(`${RECEIVERS_ADD_SUFIX}`)}
      />
    );
  };
  const renderPagingButton = () => {
    if (!isShowPagingButton) return null;
    if (!isDesktop)
      return (
        <PaginationLazy
          applyFiltered={applyFiltered}
          searchValue={searchValue}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          receivers={receivers}
          setReceivers={setReceivers}
          currentTab={currentTab}
          isSearched={isSearched}
        />
      );
    return null;
  };
  const renderFilteredPills = () => {
    if (!isShowPillFiltered) return null;
    return (
      <SearchFilterSection>
        {Object.keys(convertFilteredKeyFixed(applyFiltered)).map((key) => {
          return renderTypeFilteredReference[key](key, applyFiltered[key]);
        })}
      </SearchFilterSection>
    );
  };
  const renderReceiverTypeTabs = () => {
    if (isDesktop) return null;
    return (
      <ReceiverTypeTabs>
        {RECEIVER_TABS.map((tab, index) => (
          <ButtonCommon
            key={tab.label}
            value={t(tab.label)}
            background="var(--ds-c-white)"
            color={
              currentTab === index
                ? 'var(--ds-c-sky-dark)'
                : 'var(--ds-c-grey-dark)'
            }
            styles={{
              fontWeight: 500,
              paddingInline: '16px',
              height: '40px',
              width: '50%',
              float: 'left',
              textTransform: 'uppercase',
              borderRadius: '0px',
              borderBottom:
                currentTab === index
                  ? '1px solid var(--ds-c-sky-dark)'
                  : 'none',
            }}
            onClick={() => handleTabOnClick(index)}
          />
        ))}
      </ReceiverTypeTabs>
    );
  };
  const renderSearchFilterActionPagingSection = () => {
    return (
      <>
        {renderReceiverTypeTabs()}
        {renderSearchInput()}
        {renderFilterButton()}
        {renderActionButton()}
        {renderPagingButton()}
        {renderFilteredPills()}
      </>
    );
  };

  const renderReceiversSection = () => {
    if (isFetchReceiversInitial) return;
    if (!isDesktop)
      return (
        <ReceiversMobile
          receivers={receivers}
          setReceivers={setReceivers}
          searchValue={searchValue}
          applyFiltered={applyFiltered}
          currentTab={currentTab}
          isSearched={isSearched}
          setSearched={setSearched}
          sortOrder={sortOrder}
          isFetching={isFetching}
          setFetching={setFetching}
        />
      );
    return (
      <Receivers
        currentPage={currentPage}
        totalPages={totalPages}
        receivers={receivers}
        setReceivers={setReceivers}
        applyFiltered={applyFiltered}
        searchValue={searchValue}
        setTotalPages={setTotalPages}
        setCurrentPage={setCurrentPage}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        totalElements={totalElements}
        setTotalElements={setTotalElements}
        isFetching={isFetching}
        setFetching={setFetching}
        currentTab={currentTab}
        isSearched={isSearched}
        setSearched={setSearched}
      />
    );
  };

  const getOuterPathContentStyle = () => {
    if (!isDesktop) return {};
    return {
      minHeight: '80vh',
    };
  };

  if (isMobile || isTablet) {
    return (
      <OuterBodyContent>
        <MobileTabMenu />
        {renderSearchFilterActionPagingSection()}
        {renderReceiversSection()}
        <NavbarFooter />
      </OuterBodyContent>
    );
  }
  return (
    <CollapsibleSideMenu>
      <OuterBodyContent>
        <OuterPathContent style={getOuterPathContentStyle()}>
          <Title>
            <Icon
              src={
                currentTab === 1
                  ? AddReceiverBizIconBlueSky
                  : AddReceiverIconYellow
              }
              width={24}
              height={24}
            />
            {t('receivers_title')}
          </Title>
          <SizeBox height={16} />
          {renderSearchFilterActionPagingSection()}
          {renderReceiversSection()}
        </OuterPathContent>
      </OuterBodyContent>
    </CollapsibleSideMenu>
  );
};

const Icon = styled.img``;

const ReceiverTypeTabs = styled.div`
  height: 40px;
  background-color: transparent;
  border-radius: 0px;
  padding: 0px;
  width: 100%;
  margin-bottom: 16px;
`;

export default ReceiversPage;
